import React, { useState, useEffect } from 'react';
import './PasswordDetail.css';

const PasswordDetail = ({ password, onClose, onPasswordUpdate }) => {
  const [category, setCategory] = useState('');
  const [site, setSite] = useState('');
  const [username, setUsername] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (password) {
      setCategory(password.category);
      setSite(password.site);
      setUsername(password.username);
      setPasswordValue(password.password);
    }
  }, [password]);

  const handleOk = async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/updatePassword', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: password.id, category, site, username, password: passwordValue }),
      });

      if (response.ok) {
        onPasswordUpdate();
        onClose();
        setMessage('密码更新成功');
      } else {
        const errorData = await response.json();
        console.error('更新密码失败', errorData);
        setMessage(`更新密码失败: ${errorData.message}`);
      }
    } catch (errorInfo) {
      console.error('验证失败:', errorInfo);
      setMessage(`更新密码失败: ${errorInfo.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="password-modal">
      <h3>修改密码</h3>
      <div>
        <label>分类:</label>
        <select
          value={category}
          onChange={e => setCategory(e.target.value)}
        >
          <option value="AI">AI</option>
          <option value="网站">网站</option>
          <option value="账号">账号</option>
          <option value="其他">其他</option>
          <option value="导入">导入</option>
        </select>
      </div>
      <div>
        <label>网站:</label>
        <input
          type="text"
          value={site}
          onChange={e => setSite(e.target.value)}
        />
      </div>
      <div>
        <label>用户名:</label>
        <input
          type="text"
          value={username}
          onChange={e => setUsername(e.target.value)}
        />
      </div>
      <div>
        <label>密码:</label>
        <input
          type="text"
          value={passwordValue}
          onChange={e => setPasswordValue(e.target.value)}
        />
      </div>
      <div className="button-container">
        <button onClick={handleOk} disabled={loading}>
          {loading ? '更新中...' : '更新'}
        </button>
        <button onClick={onClose}>取消</button>
      </div>
      {message && <div>{message}</div>}
    </div>
  );
};

export default PasswordDetail;
